module.exports = __webpack_public_path__ + "img/pic_location_HsinchuCounty.7fff681c.png";